import { Layout } from 'antd';
import React from 'react';

const { Content } = Layout;

export default function ContentComponent(props: { children: React.ReactNode; className?: string; backgroundCol?: string }) {
  const { children, className, backgroundCol } = props;
  return <Content style={{ backgroundColor: backgroundCol }} className={`content ${className || ''}`}>{children}</Content>;
}
